module.exports = __webpack_public_path__ + "img/BlickAufsMeer.7d113181.svg";